import { createContext, ReactNode, useEffect, useState } from 'react';

interface Props {
  children: ReactNode,
}

interface Context {
  json: null | string,
  imgFolder: null |　string,
  segment?: [number, number],
  setBg: (json: null | string, imgFolder?: string, segment?: [number, number]) => void,
  setSegment: (segment: [number, number]) => void,
}

const DEFAULTCONTEXT: Context = {
  json: '1-game-cover/cover-background',
  imgFolder: '1-game-cover/background',
  setBg: (_json: null | string, _imgFolder?: string, _segment?: [number, number]) => { },
  setSegment: (_segment: [number, number]) => { },
};

export const BackgroundContext = createContext<Context>(DEFAULTCONTEXT);

export default function BackgroundProvider(props: Props) {
  const [value, setValue] = useState<Context>(DEFAULTCONTEXT);

  useEffect(() => {
    setValue(o => ({
      ...o,
      setBg: (json: null | string, newImgFolder?: string, segment?: [number, number]) => {
        // console.log('setBg', json, newImgFolder);
        setValue(o => ({ ...o, segment, json, imgFolder: newImgFolder ?? json }))
      },
      setSegment: (segment: [number, number]) => setValue(o => ({ ...o, segment })),
    }))
  }, []);

  return (
    <BackgroundContext.Provider value={value}>
      {props.children}
    </BackgroundContext.Provider>
  )
}
